import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
import { ChakraProvider, Box } from "@chakra-ui/react";
import Navbar from "./components/Navbar";
import Dashboard from "./components/Dashboard";
import Transactions from "./components/Transactions";
import AddTransaction from "./components/AddTransaction";
import EditTransaction from "./components/EditTransaction";
import Login from "./components/Login";
import Register from "./components/Register";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import Home from "./components/Home";

const PrivateRoute = () => {
  const { isAuthenticated, isLoading } = React.useContext(AuthContext);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <ChakraProvider>
        <AuthProvider>
          <Router basename="/react-app">
            <Box>
              <Navbar />
              <Box p={4}>
                <Routes>
                  <Route path="/" element={<Home />} />

                  <Route element={<PrivateRoute />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                  </Route>

                  <Route path="/transactions" element={<Transactions />} />
                  <Route path="/add-transaction" element={<AddTransaction />} />
                  <Route
                    path="/edit-transaction/:id"
                    element={<EditTransaction />}
                  />

                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                </Routes>
              </Box>
            </Box>
          </Router>
        </AuthProvider>
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
